import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay-failed',
  templateUrl: './pay-failed.component.html',
  styleUrls: ['./pay-failed.component.scss']
})
export class PayFailedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
